import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { isSmallBusiness } from '../../../../domain/qualification';
import { YouCanComeBackNote } from '../../../../general/components/footers/you-can-come-back-note';
import { WizardPage } from '../../../../general/components/wizard-page';
import { SPEND_INTENT } from '../../../../paths';
import { RootState } from '../../../../store';
import { resetAddressLookup } from '../../../address-verification/reducers/addressLookup';
import { PersonalInfoForm } from '../../components/personal-info-form';
import { resetPersonalInfoAttestations } from '../../reducers/personalInfo';

const selector = ({
  nextStep: { error: appError },
  addressLookup: { error: addressError },
  businessInfo: { info: businessInfo },
}: RootState) => ({
  error: appError ?? addressError,
  businessInfo,
});

const PersonalInfoPage: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { businessInfo, error } = useSelector(selector);
  const smallBusiness = isSmallBusiness(businessInfo);
  const subText = smallBusiness ? (
    <>
      We need this to be the information of a business owner or <br />
      someone with significant management responsibility.
    </>
  ) : (
    'Let us know how to refer to you.'
  );

  const handleBack = () => {
    navigate(SPEND_INTENT);
  };

  useEffect(() => {
    dispatch(resetAddressLookup());
    dispatch(resetPersonalInfoAttestations());
  }, [dispatch]);

  return (
    <WizardPage
      title="Tell us about yourself"
      subtext={subText}
      onBack={handleBack}
      error={error}
      footer={<YouCanComeBackNote />}
    >
      <PersonalInfoForm />
    </WizardPage>
  );
};

export { PersonalInfoPage };
